import { useEffect } from 'react';

function waitForElement(selector: string) {
  return new Promise<Element>((resolve) => {
    if (document.querySelector(selector)) {
      resolve(document.querySelector(selector)!);
      return;
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector)!);
      }
    });

    // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

export default function useWaitForElement(
  selector: string,
  callback: (element: HTMLElement) => void,
) {
  useEffect(() => {
    waitForElement(selector).then(callback);
  }, [selector, callback]);
}
